import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Button } from "../ui/button";
import { Clock } from "lucide-react";

/** Jul-2026 (User-Wunsch): Stempel-Erinnerung als In-System-Hinweis — auch im
 *  Händler-Kontext, wenn ein Mitarbeiter-Konto mit derselben E-Mail existiert. */
export const TimeReminderNudge = () => {
    const [reminder, setReminder] = useState(null);
    const [busy, setBusy] = useState(false);

    const load = useCallback(async () => {
        try {
            const { data } = await api.get("/me/time/reminder-hint");
            setReminder(data.reminder || null);
        } catch { setReminder(null); }
    }, []);
    useEffect(() => {
        load();
        const t = setInterval(load, 5 * 60 * 1000);
        return () => clearInterval(t);
    }, [load]);

    if (!reminder) return null;
    const isIn = reminder === "clock_in";
    const punch = async () => {
        setBusy(true);
        try {
            const { data } = await api.post("/me/time/reminder-punch", {});
            toast.success(data.action === "clock_in" ? "Eingestempelt — guten Arbeitstag!" : "Ausgestempelt — Feierabend!");
            setReminder(null);
        } catch (e) { toast.error(e.response?.data?.detail || "Stempeln fehlgeschlagen"); }
        setBusy(false);
    };
    return (
        <div className="mb-4 rounded-sm border-2 border-red-400 bg-red-50 px-4 py-3 flex flex-wrap items-center gap-3" data-testid="time-reminder-nudge">
            <Clock className="w-5 h-5 text-red-600 shrink-0 animate-pulse" />
            <p className="flex-1 min-w-[220px] text-sm font-bold text-red-800">
                {isIn
                    ? "Zeiterfassung: Du bist heute eingeplant, aber noch nicht eingestempelt!"
                    : "Zeiterfassung: Deine Arbeitszeit läuft noch — bitte ausstempeln!"}
            </p>
            <Button size="sm" onClick={punch} disabled={busy}
                className="h-8 bg-red-600 hover:bg-red-700 text-white font-bold shrink-0" data-testid="time-reminder-nudge-action">
                {isIn ? "Jetzt einstempeln" : "Jetzt ausstempeln"}
            </Button>
        </div>
    );
};
